module.exports = __webpack_public_path__ + "img/497.fa928938.jpg";